import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Leaf } from 'lucide-react';

const sway = keyframes`
  0%   { transform: rotate(-12deg) translateY(0);   }
  50%  { transform: rotate( 12deg) translateY(-6px);}
  100% { transform: rotate(-12deg) translateY(0);   }
`;

const LoadingContainer = styled.div`
    position: relative;
    width: 100%;
    min-height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #424a46;
    padding: 16px;

    & > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

const LoaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.12));
`;

const LoadingText = styled.div`
    margin-top: 10px;
    color: #424a46;
    font-size: 14px;
    text-align: center;
    opacity: 0.9;
`;

const LeafIcon = styled(Leaf)`
    animation: ${sway} 1.2s ease-in-out infinite;
    opacity: 0.95;

    &:nth-child(1) {
        color: #6ea44c;
        animation-delay: 0s;
    }
    &:nth-child(2) {
        color: #4f8c3e;
        animation-delay: 0.15s;
    }
    &:nth-child(3) {
        color: #004d37;
        animation-delay: 0.3s;
    }
`;

const LeafLoader = ({ message = 'Loading…' }) => (
    <LoadingContainer role="status" aria-live="polite">
        <div>
            <LoaderRow>
                <LeafIcon size={28} strokeWidth={2.5} />
                <LeafIcon size={28} strokeWidth={2.5} />
                <LeafIcon size={28} strokeWidth={2.5} />
            </LoaderRow>
            <LoadingText>{message}</LoadingText>
        </div>
    </LoadingContainer>
);

export default LeafLoader;
